/*
 * @Author: qgq-qiguoqing 18439339670@163.com
 * @Date: 2022-08-11 10:18:48
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2023-05-12 11:13:00
 * @FilePath: /mmtv2-frontend-pc/packages/share/components/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineAsyncComponent } from "vue";
import YQuery from "./yQuery/YQuery.vue";
import YQueryItem from "./yQuery/YQueryItem.vue";
import YFetch from "./yFetch";
import YButton from "./YButton.vue";
import YDetailSimple from "./YDetailSimple.vue";
import YView from "./YView.vue";
import YImageView from "./YImageView.vue";
import YImageMagnifier from "./YImageMagnifier.vue";

import YEmpty from "./YEmpty.vue";
import YExport from "./YExport.vue";
import YTabs from "./YTabs.vue";
import YTabsSimple from "./YTabsSimple.vue";

import YAddValue from "./YAddValue.vue";
import SensitiveInformation from "./SensitiveInformation.vue";
export default {
  install(app: any) {
    // 此处形参为main.js文件中use()方法自动传进来的Vue实例
    app.component("YAddValue", YAddValue);
    app.component("YTabs", YTabs);
    app.component("YTabsSimple", YTabsSimple);

    app.component("YQuery", YQuery);
    app.component("YExport", YExport);
    app.component("YFetch", YFetch);
    app.component("YQueryItem", YQueryItem);
    app.component("YButton", YButton);
    app.component("YDetailSimple", YDetailSimple);
    app.component("YView", YView);
    app.component("YImageView", YImageView);
    app.component("YImageMagnifier", YImageMagnifier);

    app.component("YEmpty", YEmpty);
    app.component("SensitiveInformation", SensitiveInformation);
    // app.component("Upload", Upload)
  },
};
